import { makeStyles } from '@material-ui/core/styles';

export const useStyles = makeStyles((theme) => ({
  root: {
    maxWidth: 550,
    borderRadius: 12,
    backgroundColor: '#EAECED',
    position: 'relative',
    boxShadow: "0 1px 14px 7px rgba(0,0,0,0.05), 0 1px 3px 0 rgba(0,0,0,0.2)",
    '& .MuiIconButton-root': {
      padding: 4
    },
  },

  dialogStyle: {
    borderRadius: '12px !important',
    maxWidth: '40%',
    maxHeight: "100%",
    backgroundColor: 'transparent',
    [theme.breakpoints.down('sm')]: {
      maxWidth: '90%'
    }
  },
 
  closeIcon: {
    position: 'absolute',
    right: 2
  },

  resetPassword: {
    color: '#007FFF',
    cursor: "pointer",
    textDecoration: 'underline'
  },

  iconContainer: {
    display: 'flex',
    alignItems: 'center',
  },

  cardBody: {
    width: '100%',
    justifyContent: 'space-between',
    alignItems: 'center',
    padding: '30px 4em 20px 4em',
    [theme.breakpoints.down('sm')]: {
      flexWrap: 'wrap',
    },
  },

  statusContainer: {
    marginBottom: 25
  },

  statusBody: {
    color: "rgba(0,0,0,0.87)",
    fontFamily: "Montserrat",
    fontSize: '2em',
    fontWeight: "bold",
  },

  btn: {
    width: 188,
    fontFamily: "Montserrat",
    fontSize: '1.5em',
    fontWeight: "600",
  },
 
  statusTitle: {
    color: "#585757",
    fontFamily: "Montserrat",
    fontSize: 24,
    fontWeight: "700",
    marginBottom: 20,
    marginTop: 0,
    textAlign: 'center',
    [theme.breakpoints.down('sm')]: {
      fontSize: 20
    },
  },

  statusSubTitle: {
    color: "#202020",
    fontFamily: "Montserrat",
    fontSize: 16,
    fontWeight: "500",
    marginBottom: 10,
    marginTop: 0,
    textAlign: 'center',
    marginTop: 16
  },

}));

